const setLayersAndSelectedComp = ({
  itemUndone,
  layerOrAnimation,
  setSelectedComponent,
  setLayerCompData,
  setAnimationObject,
}) => {
  let currentLayer = "";
  if (layerOrAnimation === "layerCompData")
    currentLayer = JSON.parse(JSON.stringify(itemUndone?.layerCompData));
  else currentLayer = JSON.parse(JSON.stringify(itemUndone?.animationObject));

  if (itemUndone?.selecetedComponent === "compdeleted") {
    setSelectedComponent("compdeleted");
    if (layerOrAnimation === "layerCompData") setLayerCompData(currentLayer);
    else setAnimationObject(currentLayer);
  } else if (layerOrAnimation === "layerCompData") {
    let filteredSelected = currentLayer.filter(
      (comp) => comp.id === itemUndone?.selecetedComponent?.id,
    )[0];

    setSelectedComponent({
      ...filteredSelected,
    });

    setLayerCompData(currentLayer);
  } else setAnimationObject(currentLayer);
};

export const useEditorUndoRedo = ({
  setundoFlag,
  setUndoAnimationObjFlag,
  listForReDo,
  addedActionsList,
  addedAnmationActionList,
  addedCanvasActionsList,
  setAddedActionsList,
  setAddedAnmationActionList,
  setAddedCanvasactionsList,
  setSelectedComponent,
  setLayerCompData,
  setAnimationObject,
  setOpenTimelinePopup,
  setMarker,
  SetPopupLeft,
  pixelToTimeConverter,
  setCanvasDimension,
  setCanvasBgChange,
  setListForReDo,
  setBgColorCanvas,
}) => {
  const handleRedo = () => {
    setundoFlag(true);
    setUndoAnimationObjFlag(true);

    let tempListForReDo = JSON.parse(JSON.stringify(listForReDo));
    let itemUndone = tempListForReDo[tempListForReDo.length - 1];

    let tempAddedActionList = JSON.parse(JSON.stringify(addedActionsList));
    let tempAddedAnimationActionList = JSON.parse(
      JSON.stringify(addedAnmationActionList),
    );
    let tempAddedCanvasActionsList = JSON.parse(
      JSON.stringify(addedCanvasActionsList),
    );

    if (itemUndone.hasOwnProperty("layerCompData")) {
      tempAddedActionList.push(tempListForReDo.pop());
      setAddedActionsList(tempAddedActionList);
      setLayersAndSelectedComp({
        itemUndone,
        layerOrAnimation: "layerCompData",
        setSelectedComponent,
        setLayerCompData,
        setAnimationObject,
      });
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
    }
    if (itemUndone.hasOwnProperty("animationObject")) {
      tempAddedAnimationActionList.push(tempListForReDo.pop());
      tempAddedActionList.push(tempListForReDo.pop());
      setAddedActionsList(tempAddedActionList);
      setAddedAnmationActionList(tempAddedAnimationActionList);
      setLayersAndSelectedComp({
        itemUndone,
        layerOrAnimation: "animationObject",
        setSelectedComponent,
        setLayerCompData,
        setAnimationObject,
      });

      if (Object.values(itemUndone.animationObject).length !== 0) {
        setLayersAndSelectedComp({
          itemUndone: tempAddedActionList[tempAddedActionList.length - 1],
          layerOrAnimation: "layerCompData",
          setSelectedComponent,
          setLayerCompData,
          setAnimationObject,
        });

        let selTemp =
          tempAddedActionList[tempAddedActionList.length - 1]
            ?.selecetedComponent;
        if (selTemp?.keyFrames?.length > 0) {
          let markerPosn = isNaN(
            parseInt(itemUndone?.selecetedComponent?.animationApllied.marker),
          )
            ? 0
            : parseInt(itemUndone?.selecetedComponent?.animationApllied.marker);
          setMarker(markerPosn);
          SetPopupLeft(markerPosn - 140);
          pixelToTimeConverter(markerPosn);

          setOpenTimelinePopup({
            popupWindow: true,
            fromUnRedo: true,
          });
        }
        if (
          tempAddedActionList[tempAddedActionList.length - 1]
            ?.selecetedComponent.animationApllied.keyFrameDeleted === "true"
        )
          setOpenTimelinePopup({
            popupWindow: false,
            fromUnRedo: true,
          });
      } else {
        setLayersAndSelectedComp({
          itemUndone: { layerCompData: [], selecetedComponent: "compdeleted" },
          layerOrAnimation: "layerCompData",
          setSelectedComponent,
          setLayerCompData,
          setAnimationObject,
        });
      }
    }
    if (itemUndone.hasOwnProperty("canvasDimension")) {
      tempAddedCanvasActionsList.push(tempListForReDo.pop());
      setAddedCanvasactionsList(tempAddedCanvasActionsList);
      setCanvasDimension(itemUndone.canvasDimension);
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
    }
    setListForReDo(tempListForReDo);
  };

  const handleCanvasUndo = () => {
    setCanvasBgChange(false);
    let tempListForReDo = JSON.parse(JSON.stringify(listForReDo));
    let tempAddedCanvasActionsList = JSON.parse(
      JSON.stringify(addedCanvasActionsList),
    );
    tempListForReDo.push(tempAddedCanvasActionsList.pop()); //LIFO
    setAddedCanvasactionsList(tempAddedCanvasActionsList);
    setListForReDo(tempListForReDo);
    setCanvasDimension(
      tempAddedCanvasActionsList[tempAddedCanvasActionsList.length - 1]
        .canvasDimension,
    );
    setBgColorCanvas(
      tempAddedCanvasActionsList[tempAddedCanvasActionsList.length - 1]
        .canvasDimension.backgroundColor,
    );
  };

  return {
    handleRedo,
    handleCanvasUndo,
  };
};
